module.exports = __webpack_public_path__ + "static/media/icon_checkout_confirm.80f300d0.svg";